import { render } from "./Draw3DSurfacePage.vue?vue&type=template&id=43631289"
import script from "./Draw3DSurfacePage.vue?vue&type=script&lang=js"
export * from "./Draw3DSurfacePage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__